import { Container, Grid, Link, Typography } from "@mui/material";
import React from "react";
import {
  BtnDiv,
  ContainerWraper,
  ContentGrid,
  EmptyGrid,
  FooterDiv,
  GradiantDiv,
  Image,
  ImageGrid,
  Paragraph,
  ParentGrid,
  SectionWraper,
  SocialDiv,
} from "./style";
import LockerMenu from "../../Components/Menu";
import CustomButton from "../../Components/CustomBtn";
const Home = () => {
  return (
    <SectionWraper maxWidth="xxl">
      <GradiantDiv />
      <ContainerWraper>
        <LockerMenu />
        <ParentGrid container>
          <EmptyGrid
            item
            xs={12}
            sx={{ height: "80px", width: "100%" }}
          ></EmptyGrid>
          <ContentGrid item xs={12} sm={6}>
            <Image src="./Image/heroHeding.png" alt="Shibarium" />
            <Paragraph>
              Introducing Baby Shibarium: Igniting the Future of Tokenomics.
              Join us on a journey of innovation and growth as we unveil a
              groundbreaking token accompanied by its own DEX swap, reshaping
              the landscape of decentralized finance.
            </Paragraph>
            <BtnDiv>
              <CustomButton>BUY NOW</CustomButton>
              <CustomButton bgc="#6FBA3F" color="#fff">
                VIEW CHART
              </CustomButton>
            </BtnDiv>
          </ContentGrid>
          <ImageGrid item xs={12} sm={6}>
            <Image src="./Image/heroImage.png" alt="Shibarium" />
          </ImageGrid>
        </ParentGrid>
        <Grid container>
          <Grid item xs={12}>
            <FooterDiv>
              <Paragraph>
                Copyright ©2023 shibarium. baby All rights reserved.
              </Paragraph>
              <SocialDiv>
                Follow us on:
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/twiter.png"
                    alt="Twiter"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/telegram.png"
                    alt="telegram"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
                <Link sx={{ zIndex: 1, cursor: "pointer" }}>
                  <img
                    src="./Image/mediam.png"
                    alt="mediam"
                    style={{ margin: "0 5px" }}
                  />
                </Link>
              </SocialDiv>
            </FooterDiv>
          </Grid>
        </Grid>
      </ContainerWraper>
    </SectionWraper>
  );
};

export default Home;
